import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-switch-button',
  standalone: true,
  templateUrl: './switch-button.component.html'
})
export class SwitchButtonComponent {
  @Input() checked: boolean = false;
  @Input() disabled: boolean = false;
  @Input() size: 'default' | 'small' = 'default';
  @Input() label: string = '';
  @Input() labelPosition: 'left' | 'right' | 'top' | 'bottom' = 'right';
  @Output() checkedChange = new EventEmitter<boolean>();

  get isSmall(): boolean { return this.size === 'small'; }

  toggle(): void {
    if (this.disabled) return;
    this.checked = !this.checked;
    this.checkedChange.emit(this.checked);
  }
}
